// Libs
import React from 'react';


//  Services
import API from 'API';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class PasswordReset extends React.Component {
   

    constructor(props, context) {
        super(props, context);
        this.state = {
            isLoading: false,
            isComplete: false,
            user: {},
            resetToken: props.resetToken
        };
        
    }

    async submit() {
        const {
            user,
            resetToken
        } = this.state;
        this.setState({ isLoading: true });
        if (this.checkPassword()) {
            try {
                
                await API.call('account/reset-password', { resetToken: resetToken, password: user.password });
                this.setState({ isLoading: false, isComplete: true });
            } catch (error) {
                this.setState({
                    isLoading: false,
                    error
                });
            }
        } else {
            this.setState({ isLoading: false });
        }
    }

    updateFields(fields) {
        const user = { ...this.state.user };
        for (let fieldName in fields) {
            const value = fields[fieldName];
            user[fieldName] = value;
        }
        this.setState({ user });
        this.checkPassword();
    }

    checkPassword() {
        if (this.state.user.password !== this.state.user.confirmpassword) {
            this.setState({ error: "Passwords do not match" });
            return false;
        }
        this.setState({ error: "" });
        return true;
    }

    render() {
        if (this.state.isComplete) {
            return (<>
                <div>
                    <p>Your password has been successfully updated.</p>
                    <button className="btn btn-primary" type="button" onClick={e => { window.location.assign("/") } }>
                        Login
                    </button>
                </div>
            </>);
        } else {
            return (<>
                <form className="panel login-panel" onSubmit={e => { e.preventDefault(); this.submit() }}>
                    {this.renderInner()}
                </form>
            </>);
        }
    }

    renderInner() {
        const {
            isLoading,
            user,
            error
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        } else {
            return (<>
                <h3>Reset Password</h3>

                <p>Please enter your new password.</p>

                {error &&
                    <div className="alert alert-danger">
                        {error}
                    </div>
                }

                <div className="form-group">
                    <label className="form-label">Password</label>
                    <input
                        type="password"
                        className="form-control"
                        value={user.password || ''}
                        onChange={e => this.updateFields({ password: e.target.value })}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Confirm Password</label>
                    <input
                        type="password"
                        className="form-control"
                        onChange={e => this.updateFields({ confirmpassword: e.target.value })}
                    />
                </div>

                <button className="btn btn-primary" type="submit">
                    Reset Password
                </button>
            </>);
        }
    }
}

export default PasswordReset;